let modals = (function( $ ) {

	let $anchors;
	let $body;

	let min_height = 400;

	let init = function() {
		$anchors = $( 'a.open-modal' );
		$body = $( 'body' );

		if ( $anchors.length > 0 ) {
			$anchors.each( _attach_handlers );

			$( document ).on( 'keydown', ( e ) => {

				if ( e.key === 'Escape' ) {
					close_all_modals();
				}
			} );
		}
	};

	let _attach_handlers = function() {
		let $anchor = $( this );
		let $modal = $( $anchor.attr( 'href' ) );

		$anchor.on( 'click', {modal: $modal}, open_modal_internal );

		$modal.find( 'a.close-modal' ).on( 'click', {modal: $modal}, _close_modal_internal );
		$body.find( '.overlay' ).on( 'click', close_all_modals );

		$anchor.trigger( 'attached-handlers' );
	};

	let open_modal_internal = function( e ) {
		$body.addClass( 'modal-open' );

		e.data.modal.fadeIn();

		e.preventDefault();
	};

	let _close_modal_internal = function ( e ) {
		if ( ! $body.hasClass( 'modal-open' ) ) {
			return;
		}

		$body.removeClass( 'modal-open' );

		e.data.modal.fadeOut();

		e.preventDefault();
	};

	let close_modal = function( $modal ) {
		if ( ! $body.hasClass( 'modal-open' ) ) {
			return;
		}

		$body.removeClass( 'modal-open' );

		$modal.fadeOut();

		$modal.trigger( 'closed' );
	};

	let open_modal = function( $modal ) {
		$body.addClass( 'modal-open' );

		$modal.find( 'a.close-modal' ).on( 'click', {modal: $modal}, _close_modal_internal );
		$body.find( '.overlay' ).on( 'click', close_all_modals );

		$modal.fadeIn();
	};

	let close_all_modals = function( e ) {
		if ( ! $body.hasClass( 'modal-open' ) ) {
			return;
		}

		$body.removeClass( 'modal-open' );

		var $modals = $( '.crate-modal' );

		$modals.fadeOut();

		$modals.trigger( 'closed' );

		if ( e ) {
			e.preventDefault();
		}
	};

	$( document ).ready( init );

	return {
		init: init,
		close_all_modals: close_all_modals,
		open_modal: open_modal,
		close_modal: close_modal,
		open_modal_internal : open_modal_internal,
	};

})( jQuery );

module.exports = modals;